import axios from '../../utils/axios.js'

export const query = (query) => axios.setAxiosGetPromise('tenant/find', query)

export const byId = (query) => axios.setAxiosGetPromise('tenant/findOne', query)

export const addOne = (options) => axios.setAxiosPostPromise('tenant/addOne', options)

export const deleteOne = (query) => axios.setAxiosDeletePromise('tenant/deleteOne', query)

export const updateOne = (options) => axios.setAxiosPutPromise('tenant/updateOne', options)



// WEBPACK FOOTER //
// ./src/services/system/tenancy.js